import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Aarthikreportnamuna5k = () => {
  const [selectedDate, setSelectedDate] = useState('2025-04-01');
  const navigate = useNavigate();

  const handleSubmit = () => {
    console.log('Form submitted:', { selectedDate });
  };

  const handleDateChange = (e) => {
    const date = e.target.value;
    setSelectedDate(date);
  };

  const handleBack = () => {
    navigate('/aarthikreport');
  };

  return (
    <div className="min-h-screen bg-gray-100 p-4">
      <div className="max-w-2xl mx-auto">
        <div className="bg-white rounded-lg shadow-lg overflow-hidden">
          
          {/* Header */}
          <div className="bg-[#267c77] text-white px-6 py-4 text-center">
            <h1 className="text-xl font-bold">नमुना 5</h1>
          </div>

          {/* Back Button */}
          <div className="px-6 py-4 bg-gray-50 border-b">
            <button
              onClick={handleBack}
              className="flex items-center gap-2 bg-gray-600 text-white px-4 py-2 rounded hover:bg-gray-700 transition-colors duration-200"
            >
              ← Back
            </button>
          </div>

          {/* Form Content */}
          <div className="p-6">
            <div className="space-y-6">
              
              {/* Date Field */}
              <div className="flex items-center space-x-4">
                <label className="text-gray-700 font-medium w-32">
                  दिनांक
                </label>
                <div className="relative flex-1">
                  <input
                    type="date"
                    value={selectedDate}
                    onChange={handleDateChange}
                    className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#267c77] focus:border-transparent"
                  />
                </div>
              </div>

            </div>

            {/* Submit Button */}
            <div className="mt-8 flex justify-center">
              <button
                onClick={handleSubmit}
                className="bg-green-600 text-white px-8 py-3 rounded-md font-medium hover:bg-green-700 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2"
              >
                नमुना 5
              </button>
            </div>

          </div>

        </div>
      </div>
    </div>
  );
};

export default Aarthikreportnamuna5k;